import { render, staticRenderFns } from "./Inner.vue?vue&type=template&id=5382b5a4&scoped=true&"
import script from "./Inner.vue?vue&type=script&lang=js&"
export * from "./Inner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382b5a4",
  null
  
)

export default component.exports